import { useEffect, useState } from 'react';
import { UserContextProvider } from './context/userContext';
import { CartContextProvider } from './context/cartContext';
import Routers from './routers/Router';
import { useAuth, hasAuthParams } from 'react-oidc-context';
import { publicUrls } from './constant/constant';
import { GuestUserContextProvider } from './context/guestContext';
import { WishListContextProvider } from './context/wishListContext';

function App() {
  const auth = useAuth();
  const [hasTriedSignin, setHasTriedSignin] = useState(false);

  const isPublicUrl = () => {
    return publicUrls.some((publicUrl) =>
      window.location.pathname.includes(publicUrl),
    );
  };

  // automatically sign-in
  useEffect(() => {
    if (
      !hasAuthParams() &&
      !auth.isAuthenticated &&
      !auth.activeNavigator &&
      !auth.isLoading &&
      !hasTriedSignin &&
      !isPublicUrl()
    ) {
      auth.signinRedirect();
      setHasTriedSignin(true);
    }
  }, [auth, hasTriedSignin]);

  if (auth.isLoading) {
    let message = 'Signing you in...';
    switch (auth.activeNavigator) {
      case 'signinSilent':
        message = 'Signing you in...';
        break;
      case 'signoutRedirect':
        message = 'Signing you out...';
        break;
    }
    return (
      <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-[480px]">
        <div>{message}</div>
      </div>
    );
  }

  if (!auth.isAuthenticated && !isPublicUrl()) {
    if (hasAuthParams() && !hasTriedSignin) {
      setHasTriedSignin(true);
      auth.signinRedirect();
    }

    return (
      <div>
        <div>Unable to log in</div>
        <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-[480px]">
          <div className="bg-white px-6 py-12 shadow sm:rounded-lg sm:px-12">
            <div>
              <button
                type="submit"
                className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm 
                font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 
                focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                onClick={() => auth.signinRedirect()}
              >
                Sign in
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      {isPublicUrl() ? (
        <div className="min-h-full">
          <div id="app">
            <UserContextProvider>
              <GuestUserContextProvider>
                <Routers />
              </GuestUserContextProvider>
            </UserContextProvider>
          </div>
        </div>
      ) : (
        <div className="min-h-full">
          <div id="app">
            <UserContextProvider>
              <CartContextProvider>
                <WishListContextProvider>
                  <Routers />
                </WishListContextProvider>
              </CartContextProvider>
            </UserContextProvider>
          </div>
        </div>
      )}
    </>
  );
}

export default App;
